import { component } from 'picoapp';

export default component((node, ctx) => {
  /**
   * Data + elements
   */
  const flagIcon = node.querySelector('.js-flagIcon');

  /**
   * Functions
   */
  const initFlagIcon = () => {
    const currentShop = window.theme.shops.find((shop) => shop.shopifyDomain === Shopify.shop && shop.countryCode === Shopify.country);
    flagIcon.innerHTML = `<img src="${currentShop.flagIcon}" class="h-[16px]" loading="lazy">`;
  };

  const initBtn = () => {
    node.addEventListener('click', () => ctx.emit('countrySelector:open'));
  };

  const init = () => {
    initFlagIcon();
    initBtn();
  };

  /**
   * Init
   */
  init();
});
